<template>
    <div class="flex flex-col items-streatch">
        <div class="text-200 mt-4 mb-3">
            <ActAsUserDropdown />
        </div>

        <div class="flex justify-start gap-2">
            <CoreButton label="§ui_button.cancel" variant="tertiary" @click="closeModal" />
        </div>
    </div>
</template>

<script>
import CoreButton from '@/components/core/CoreButton.vue'
import ActAsUserDropdown from '@/components/ActAsUserDropdown.vue'
import { useModalStore } from '@/stores/modal'

export default {
    name: 'ActAsUserModal',

    components: {
        CoreButton,
        ActAsUserDropdown,
    },

    data() {
        return {
            modalStore: useModalStore(),
        }
    },

    beforeUnmount() {
        this.$router.back()
    },

    unmounted() {
        this.modalStore.setOpen({
            name: 'ConfirmActionModal',
            size: 'small',
            title: '§ui.modal_title_internal_user_no_oem_login',
            data: {
                cancelButtonLabel: '§ui_button.cancel',
            },
        })
    },

    methods: {
        closeModal() {
            this.modalStore.setClose()
        },
    },
}
</script>
